import { ErrorHandler, Injectable } from '@angular/core';

/**
 * Intercepta ChunkLoadError (lazy loading falla tras un nuevo deploy)
 * y recarga la página automáticamente para obtener los chunks actualizados.
 * Usa localStorage con timestamp para evitar loops infinitos de reload
 * (sessionStorage se limpia en AppComponent constructor).
 */
@Injectable()
export class ChunkErrorHandler implements ErrorHandler {
  private static readonly RELOAD_KEY = 'chunk_reload_ts';
  private static readonly RELOAD_WINDOW_MS = 10_000; // 10 segundos

  handleError(error: any): void {
    const chunkFailedMessage = /Loading chunk .* failed|Failed to fetch dynamically imported module|Failed to load module script/i;
    const innerError = error?.rejection || error;

    if (chunkFailedMessage.test(innerError?.message || '')) {
      const lastReload = Number(localStorage.getItem(ChunkErrorHandler.RELOAD_KEY) || '0');
      const now = Date.now();

      if (now - lastReload > ChunkErrorHandler.RELOAD_WINDOW_MS) {
        // No hubo reload reciente → recargar para obtener chunks nuevos
        localStorage.setItem(ChunkErrorHandler.RELOAD_KEY, String(now));
        window.location.reload();
        return;
      }
      // Ya se recargó hace menos de 10s → no hacer loop, limpiar y mostrar error
      localStorage.removeItem(ChunkErrorHandler.RELOAD_KEY);
    }

    // Comportamiento por defecto para errores no-chunk
    console.error(error);
  }
}
